import { atom } from "jotai";
interface TripodItem {
    id: number;
    title: string;
    price: number;
    quantity: number;
    price_id: string
}
interface AccessoryItem {
    id: number;
    image: any;
    title: string;
    price: number;
    quantity: number;
    price_id: string


}

interface SubscriptionItem {
    price: number;
    title: string
}

interface FormValuesClub {
    name: string;
    lastname: string;
    clubName: string;
    adminClubEmail: string
}

interface FormValuesBilling {
    name: string,
    surname: string,
    plan_id: string,
    mail: string,
    country_code: string,
    city: string,
    zip_code: string,
    street_address: string,
    payment_method: string,
    apartment: string,
}

export const tripodsAtom = atom<TripodItem[]>([])


export const accessoriesAtom = atom<AccessoryItem[]>([])


export const numberWizards = atom(1)

export const selectedSubscription = atom<any>({
    price: 0,
    title: "",
})


export const formValuesClubAtom = atom<FormValuesClub>({
    name: "",
    lastname: "",
    clubName: "",
    adminClubEmail: "",
})
export const formValuesBillingAtom = atom<FormValuesBilling>({
    name: "",
    surname: "",
    plan_id: "5",
    mail: "",
    country_code: "",
    city: "",
    zip_code: "",
    street_address: "",
    payment_method: "Credit card",
    apartment: "",
})

export const itemsAtom = atom({
    wizards: {
        type: null,
        quantity: 1,
        price: 0,
        totalPrice: 0,
    },
    subscriptions: {
        type: null,
        price: 0,
    },
    tripods: {
        type: null,
        price: 0,
        quantity: 0,
    },
    accessories: {
        type: null,
        price: 0,
        quantity: 0,
    },
    clubDetails: {
        name: null,
        lastname: null,
        clubName: null,
        adminEmail: null,
        clubDivision: null,
        clubCategory: null,
        clubCountry: null,
    },
    deliveryBillingDetails: {
        name: null,
        lastname: null,
        emailAddress: null,
        phoneNumber: null,
        streetAddress: null,
        apartment: null,
        country: null,
        city: null,
        zipCode: null,
        ivaNumber: null,
    },
    paymentDetails: {
        cardName: null,
        cardNumber: null,
        dateExpire: null,
        cvvNumber: null,
    },
});
